module.exports = __webpack_public_path__ + "media/react/components/Exception/500-423bdbe3ed84ba192f260c859b331ed4.svg";